import React from "react";

import {templates} from "@reactivated";

import {Layout} from "@client/components/Layout";
import { ErrorPage } from "@client/components/ErrorPage";


export const Template = (props: templates.ResearchPage) => (
    <Layout title="Research">
        <ErrorPage
            title="Research"
            description="Coming soon. Keep an eye out for comms when this feature comes online."
        ></ErrorPage>
    </Layout>
);
